<template>
    <div class="m-hrlogin" :style="{'backgroundColor': theme===1? '#333':'#F4F9FF'}">
        <div class="wrap" v-if="theme===1">
            <img class="loading" src="../../assets/images/login/loader.gif" alt="">
            <h1 class="title">正在跳转到培训平台...</h1>
        </div>
        <div class="wrap2" v-if="theme===2">
            <img class="loading" src="../../assets/images/login/gears-animation.gif" alt="">
            <h1 class="title">正在跳转到培训平台...</h1>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import {Storage, Ticket} from "@/utils";
    import {oaURL} from '@/api/http'
    const config = require("@/config");

    export default {
        components: {},
        data() {
            return {
                theme: 2
            }
        },
        mounted() {
            this.login();
        },
        computed: {},
        methods: {
            login() {
                let ticket = this.$route.query.ticket;

                if (!ticket) {
                    this.$alert('登录失败！请重新登录', '登录失败').then(res => {
                        window.location.href = oaURL;
                    }).catch(e => {
                        window.location.href = oaURL;
                    });

                    return;
                }

                api
                    .hrLogin({
                        ticket,
                        version: config.version
                    })
                    .then(result => {
                        Ticket.set(result.package);

                        return api.getUserMenus();
                    })
                    .then(res => {
                        if (!Ticket.get()) return Promise.reject();

                        if (!res.package.length) {
                            this.$message(this.$t('m.emptyMenuLogin'));
                            return Promise.reject();
                        }

                        setTimeout(() => {
                            this.initData(res.package);
                        }, 500)
                    })
                    .catch(err => {
                        console.log(err);
                        setTimeout(() => {
                            window.location.href = oaURL;
                        }, 2000)
                    });
            },

            // 初始化vuex数据、菜单持久化及跳转
            initData(menuData) {

                // 1. 初始化主题、用户数据和系统信息
                this.$store.commit("initAppTheme");
                this.$store.commit("initUserInfo");
                this.$store.dispatch("getSystemInfo");

                // 2. 初始化学员和培训师的dashboard，并跳转
                // role: 1管理员 2培训师 3学员 4超管
                let role = Ticket.get().type;
                let dashboard = {
                    // 培训师
                    2: {
                        name: this.$t('app.dashboard'),
                        path: "/teacher/home",
                    },
                    // 学员
                    3: {
                        name: this.$t('app.dashboard'),
                        path: "/student/home",
                    }
                };

                if (role === 2 || role === 3) {
                    // 如果“学员”这个父级菜单被配置
                    if (role === 3 && menuData[0].children.length) {
                        menuData = menuData[0].children
                    }

                    menuData.unshift({
                        id: 0,
                        order: 0,
                        superiorID: null,
                        name: dashboard[role].name,
                        iconClass: "inuc-dashboard",
                        path: dashboard[role].path,
                        children: []
                    });
                    this.$router.push(dashboard[role].path);

                } else {
                    this.$router.push(menuData[0].children.length ? menuData[0].children[0].path : menuData[0].path);
                }

                // 3. 存储菜单数据
                Storage.set("menu", menuData);

                //console.log("用户信息", Ticket.get());
            },
        },
        watch: {},
    }
</script>

<style scoped lang="scss">

    .loading {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .m-hrlogin {
        height: 100%;
        background-color: #F4F9FF;
    }

    .title {
        position: absolute;
        top: 60%;
        width: 100%;
        text-align: center;
        font-size: 32px;
        color: #fff;
        letter-spacing: 2px;
    }

    .wrap2 {
        .title {
            color: #333;
        }
    }
</style>
